import { Card, Heading, Text, Stack, Image } from "@chakra-ui/react";
import React from "react";
import { FilledButton, GreenFilledButton } from "./Button";
import AppointButton from "./AppointButton";
import { useColorModeValue } from "../ui/color-mode";

const CustomCard = ({
  src,
  title,
  description,
  button1,
  url1,
  backgroundColor1,
  backgroundColor2,
  button2,
  url2,
  icon1,
  icon2,
  children,
  borderRadius = "2xl",
  boxShadow = "rgba(0, 0, 0, 0.04) 0px 3px 5px",
  lineClamp = "4",
  boxSize = 82,
  ...props
}) => {
  const bg = useColorModeValue("#f6f6ff", "#1a1625");
  return (
    <>
      <Card.Root
        variant="outline"
        alignItems="center"
        borderRadius={borderRadius}
        boxShadow={boxShadow}
        maxW="md"
        textAlign="left"
        bgColor={bg}
        {...props}
      >
        <Card.Body>
          {src && <Image src={src} boxSize={boxSize} />}
          <Heading
            size={{ base: "10", md: "xl", lg: "xl" }}
            py={3}
            fontWeight="bold"
          >
            {title}
          </Heading>
          <Text lineClamp={lineClamp} color="gray.500">
            {description}
          </Text>
          <Stack direction={{ base: "column", md: "row" }} mt={5} gap={5}>
            {button1 && (
              <AppointButton
                text={
                  <FilledButton
                    backgroundColor={backgroundColor1}
                    title={button1}
                    icon={icon1}
                    size="md"
                    w={{ base: "full", md: "fit-content" }}
                  />
                }
              />
            )}
            {button2 && (
              <GreenFilledButton
                backgroundColor={backgroundColor2}
                title={button2}
                url={url2}
                icon={icon2}
                size="md"
                w={{ base: "full", md: "fit-content" }}
              />
            )}
          </Stack>
          <Stack>{children}</Stack>
        </Card.Body>
      </Card.Root>
    </>
  );
};

export default CustomCard;
